// XSM-1536 - SSO Feature + Refresh Token
import React from "react";
import {
  unstable_HistoryRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import MainLayout from "@layout/index";
import history from "@utils/history";
import { AdapterProvider } from "@pages/adapters/adapterContext";
import { ApiIntegratorProvider } from "@pages/integration.manager/api.integrator.new/apiIntegratorContext";

const Homepage = React.lazy(() => import("@pages/home"));
const ViewTasks = React.lazy(() => import("@pages/tasks/view.tasks"));
const ViewAlerts = React.lazy(() => import("@pages/alerts/view.alerts"));
const ManageAlerts = React.lazy(() => import("@pages/alerts/manage.alert"));
const CreateAlert = React.lazy(() => import("@pages/alerts/create.alert"));
const ConfigureAdapters = React.lazy(
  () => import("@pages/adapters/configure.adapters")
);
//const ViewAdapters = React.lazy(() => import("@pages/adapters/view.adapters"))
const Adapter = React.lazy(
  () => import("@pages/adapters/configure.adapters/adapter")
);
const ProcessDefinition = React.lazy(
  () =>
    import(
      "@pages/integration.manager/process.integrator.new/process.defination"
    )
);

const ProcessInstances = React.lazy(
  () =>
    import(
      "@pages/integration.manager/process.integrator.new/process.instances"
    )
);
const ProcessTemplates = React.lazy(
  () =>
    import("@pages/integration.manager/process.integrator/process.templates")
);
const ProcessTemplatesNew = React.lazy(
  () =>
    import(
      "@pages/integration.manager/process.integrator/process.templates/Processtemplatenew"
    )
);

const CredentialManager = React.lazy(
  () =>
    import(
      "@pages/integration.manager/process.integrator.new/credential.manager"
    )
);

const APIIntegrator = React.lazy(
  () => import("@pages/integration.manager/api.integrator")
);

const APIIntegratorNew = React.lazy(
  () => import("@pages/integration.manager/api.integrator.new")
);

const WorkflowDesigner = React.lazy(
  () =>
    import(
      "@pages/integration.manager/process.integrator.new/workflow.designer"
    )
);
const ViewAdaptersNew = React.lazy(
  () => import("@pages/adapters/view.new.adapters")
);

const ViewOTAssets = React.lazy(
  () => import("@pages/ot.assets/screens/view.assets")
);

const RegisterOTAsset = React.lazy(
  () => import("@pages/ot.assets/screens/register")
);

const DeviceDashboard = React.lazy(
  () => import("@pages/ot.assets/screens/dashboard")
);

const ProfileOTAsset = React.lazy(
  () => import("@pages/ot.assets/screens/profile")
);

const LoadingScreen = React.lazy(() => import("@pages/landing"));

const Login = React.lazy(() => import("@pages/login"));

const ErrorPage = React.lazy(() => import("@pages/errorpage"));
const OpenSearch = React.lazy(() => import("@pages/open.search"));

function App() {
  return (
    <ApiIntegratorProvider>
      <AdapterProvider>
        <Router history={history as any}>
          <Routes>
            <Route path="/error-page" element={<ErrorPage />} />
            <Route path="/landing" element={<LoadingScreen />} />
            <Route path="/" element={<Login />} />
            <Route path="/*" element={<MainLayout />}>
              <Route path="dashboard" element={<Homepage />} />
              <Route
                path="workflow-definitions/*"
                element={<WorkflowDesigner />}
              />
              <Route
                path="workflow-instances/*"
                element={<WorkflowDesigner />}
              />
              <Route
                path="workflow-registry/*"
                element={<WorkflowDesigner />}
              />
              {/* <Route path="view-adapters" element={<ViewAdapters />} /> */}
              <Route path="view-adapters" element={<ViewAdaptersNew />} />
              <Route
                path="configure-adapters"
                element={<ConfigureAdapters />}
              />
              <Route
                path="configure-adapters/:id/:adapterName"
                element={<Adapter />}
              />
              <Route
                path="process-definitions"
                element={<ProcessDefinition />}
              />
              <Route path="process-instances" element={<ProcessInstances />} />
              <Route path="api-integrator" element={<APIIntegratorNew />} />
              <Route
                path="process-templates-old"
                element={<ProcessTemplates />}
              />
              <Route
                path="process-templates"
                element={<ProcessTemplatesNew />}
              />
              <Route
                path="credential-manager"
                element={<CredentialManager />}
              />
              <Route path="system-logs" element={<OpenSearch />} />
              <Route path="view-tasks" element={<ViewTasks />} />
              <Route path="create-alert" element={<CreateAlert />} />
              <Route path="manage-alerts" element={<ManageAlerts />} />
              <Route path="view-alerts" element={<ViewAlerts />} />
              <Route path="ot-assests" element={<ViewOTAssets />} />
              <Route path="ot-assests/register" element={<RegisterOTAsset />} />
              <Route
                path="ot-assests/dashboard"
                element={<DeviceDashboard />}
              />
              <Route path="ot-assests/profile" element={<ProfileOTAsset />} />
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Route>
            <Route path="*" element={<Navigate to="/error-page" replace />} />
          </Routes>
        </Router>
      </AdapterProvider>
    </ApiIntegratorProvider>
  );
}

export default App;
